export const FEEDBACK_MONTHS_LOOKBACK = 12;

/**
 * Threshold to determine whether or not to concatenate
 * feedbacks incidentDetails and comments. If the fields are
 * greater than this thresholds then we determine them to be too
 * similar and we just display incidentDetails.
 */
export const FEEDBACK_SIMILARITY_PERCENTAGE_THRESHOLD = 0.9;
